<template>
  <div class="mdl-grid">
    <div class="mdl-cell mdl-cell--12-col">
      <h1 class="mdl-typography--text-center"><i class="material-icons">dvr</i></h1>
    </div>

    <div class="mdl-cell mdl-cell--12-col">
      <p class="mdl-typography--text-center">
        Aquí se mostrarán los reportes mas recientes que hayas realizado.<br>
        Comienza un proceso de Auditoría en cualquiera de los inmuebles asignados para ti.
      </p>
    </div>

    <div class="mdl-cell mdl-cell--12-col mdl-typography--text-center">
      <router-link to="/auditoria"
        class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored">
        Generar auditoría
      </router-link>

      <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored"
        @click="$emit('refresh', true)">
        Actualizar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
  .mdl-grid {
    margin-top: 5rem;
  }

  .mdl-grid h1 i.material-icons {
    font-size: 6rem;
    color: rgb(148, 144, 148);
  }

  .mdl-grid p {
    color: rgb(148, 144, 148) !important;
  }
</style>


// WEBPACK FOOTER //
// Empty.vue?339c41ae